export default __webpack_public_path__ + "783671348d960200ff897e1c0f670909.svg";